import { createEntityAdapter } from '@reduxjs/toolkit';
import { ICategoryItemData } from 'services/shop/types/categories';
import { IAppointmentState } from '../types/reducer';

export type ISpecialServiceByStaffItem = {
  id: string;
  loading: boolean;
  categories: ICategoryItemData[];
};

export const specialServiceByStaffsAdapter =
  createEntityAdapter<ISpecialServiceByStaffItem>();
export const specialServiceByStaffsSelect =
  specialServiceByStaffsAdapter.getSelectors<IAppointmentState>(
    (state) => state.specialServiceByStaffs
  );
